import createReactComponent from '../createReactComponent';
var ExternalLink = createReactComponent('ExternalLink', [['path', {
  d: 'M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6',
  key: '1vjhz7'
}], ['polyline', {
  points: '15 3 21 3 21 9',
  key: 'mznyad'
}], ['line', {
  x1: '10',
  y1: '14',
  x2: '21',
  y2: '3',
  key: '19d9un'
}]]);
export default ExternalLink;